<template>
  <template v-if="isShareBuild">
    <ShareBrowseHeader />
    <router-view />
  </template>
  <template v-else-if="isFullscreenRoute">
    <router-view />
  </template>
  <template v-else>
    <Layout />
  </template>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Layout from './components/Layout.vue';
import ShareBrowseHeader from './views/ShareBrowseHeader.vue';

const route = useRoute();

/** 分享构建（publish:completed）：无顶栏/侧栏，仅 manifest 登记页 */
const isShareBuild = process.env.PREVIEW_SHARE_BUILD === '1';

// 判断是否为全屏页面（无导航）
const isFullscreenRoute = computed(() => {
  const p = route.path;
  return p === '/traffic-tunnel' ||
         p.startsWith('/traffic-tunnel/') ||
         p.startsWith('/design-test/') ||
         p.startsWith('/completed-pages/p/') ||
         p.startsWith('/business/page-layouts/p/');
});
</script>

<style lang="scss">
// 全局样式入口保留；表格筛选菜单样式统一收敛到 component-library/styles/_element-plus.scss。
</style>
